import { FuseNavigation } from '@fuse/types';

export const navigationVendedor: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'tablero',
                title: 'NAV.TABLERO',
                type: 'item',
                icon: 'email',
                url: '/tablero'
            },
            {
                id: 'rutero',
                title: 'NAV.RUTERO',
                type: 'item',
                icon: 'trending_up',
                url: '/rutero'
            },
            {
                id: 'consultaExistencias',
                title: 'NAV.CONSULTA_EXISTENCIAS',
                type: 'item',
                icon: 'find_in_page',
                url: '/consultaExistencias'
            },
            {
                id: 'consulta',
                title: 'Consulta',
                translate: 'NAV.CONSULTA',
                type: 'item',
                icon: 'search',
                url: '/consulta'

            },
            {
                id: 'indicadores',
                title: 'NAV.INDICADORES',
                type: 'collapsable',
                icon: 'bar_chart',
                children: [
                    {
                        id: 'resumenGestion',
                        title: 'NAV.RESUMEN_GESTION',
                        type: 'item',
                        url: '/indicadores/resumenGestion'
                    }
                ]
            }
        ]
    }
];

export const navigationTelemercaderista: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'rutero',
                title: 'NAV.RUTERO',
                type: 'item',
                icon: 'trending_up',
                url: '/telemercaderista'
            },
            {
                id: 'consultaExistencias',
                title: 'NAV.CONSULTA_EXISTENCIAS',
                type: 'item',
                icon: 'find_in_page',
                url: '/consultaExistencias'
            },
            {
                id: 'consulta',
                title: 'Consulta',
                translate: 'NAV.CONSULTA',
                type: 'item',
                icon: 'search',
                url: '/consulta'
            }
        ]
    }
];

export const navigationLogistica: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'rutero',
                title: 'NAV.RUTERO',
                type: 'item',
                icon: 'trending_up',
                url: '/telemercaderista'
            },
            {
                id: 'ordenRecoleccionNc',
                title: 'OrdenRecoleccionNc',
                translate: 'NAV.ORDEN_RECOLECCION_NC',
                type: 'item',
                icon: 'description',
                url: '/ordenRecoleccionNc'
            },
            {
                id: 'OrdenRecoleccionGarantia',
                title: 'OrdenRecoleccionGarantia',
                translate: 'NAV.ORDEN_RECOLECCION_GARANTIA',
                type: 'item',
                icon: 'replay',
                url: '/ordenRecoleccionGarantia'
            },
            {
                id: 'consulta',
                title: 'Consulta',
                translate: 'NAV.CONSULTA',
                type: 'item',
                icon: 'search',
                url: '/consulta'
            }
        ]
    }
];

export const navigationFacturador: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'pedidosSinBandeja',
                title: 'NAV.PEDIDOS_SIN_BANDEJA',
                type: 'item',
                icon: 'trending_up',
                url: '/pedidosSinBandeja'
            },
            {
                id: 'historicoAutorizacion',
                title: 'Historico autorización',
                translate: 'NAV.HISTORICO_AUTORIZACION',
                type: 'item',
                icon: 'description',
                url: '/historicoAutorizaciones'
            }
        ]
    }
];

export const navigationPedido: FuseNavigation[] = [
    {
        id: 'PROMOCIONES',
        title: 'NAV2.PROMOCIONES',
        type: 'item',
        icon: 'search',
        url: '/tomarPedido/promociones'
    },
    {
        id: 'RESTABLECER',
        title: 'NAV2.RESTABLECER',
        type: 'item',
        icon: 'search',
        url: '/tomarPedido/restablecer'
    },
    {
        id: 'ADICIONAR',
        title: 'NAV2.ADICIONAR',
        type: 'item',
        icon: 'card_giftcard',
        url: 'tomarPedido/manual'
    },
    {
        id: 'SUGERIDO',
        title: 'NAV2.SUGERIDO_1',
        type: 'item',
        icon: 'record_voice_over',
        url: 'tomarPedido/inventario'
    }
];

export const navigationAutorizadorLogistica: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'autorizaciones',
                title: 'NAV.AUTORIZACIONES',
                type: 'item',
                icon: 'description',
                url: '/autorizador'
            },
            {
                id: 'historicoAutorizacion',
                title: 'Historico autorización',
                translate: 'NAV.HISTORICO_AUTORIZACION',
                type: 'item',
                icon: 'description',
                url: '/historico-autorizaciones'
            },
            {
                id: 'pedidosEscalados',
                title: 'Pedidos escalados',
                translate: 'NAV.PEDIDOS_ESCALADOS',
                type: 'item',
                icon: 'description',
                url: '/pedidos-escalados'
            },
            {
                id: 'ventasPerdidas',
                title: 'NAV.VENTAS_PERDIDAS',
                type: 'item',
                icon: 'description',
                url: '/ventas-perdidas'
            },
            {
                id: 'consultaPedidos',
                title: 'NAV.CONSULTA_PEDIDOS',
                type: 'item',
                icon: 'trending_up',
                url: '/facturadorLogistica'
            }
        ]
    }
];

export const navigationAutorizador: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'autorizaciones',
                title: 'NAV.AUTORIZACIONES',
                type: 'item',
                icon: 'description',
                url: '/autorizador'
            },
            {
                id: 'historicoAutorizacion',
                title: 'Historico autorización',
                translate: 'NAV.HISTORICO_AUTORIZACION',
                type: 'item',
                icon: 'description',
                url: '/historico-autorizaciones'
            },
            {
                id: 'pedidosEscalados',
                title: 'Pedidos escalados',
                translate: 'NAV.PEDIDOS_ESCALADOS',
                type: 'item',
                icon: 'description',
                url: '/pedidos-escalados'
            },
            {
                id: 'ventasPerdidas',
                title: 'NAV.VENTAS_PERDIDAS',
                type: 'item',
                icon: 'description',
                url: '/ventas-perdidas'
            }
        ]
    }
];
export const navigationAdministrador: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'gestionAdministrador',
                title: 'NAV.GESTION_ADMINISTRADOR',
                type: 'item',
                icon: 'settings',
                url: '/gestion-autorizador'
            },
            {
                id: 'cargarPromociones',
                title: 'NAV.CARGA_PROMOCIONES',
                type: 'item',
                icon: 'settings',
                url: '/cargar-promociones'                
            },
            {
                id: 'gestionPedido',
                title: 'NAV.PEDIDOS_SIN_BANDEJA',
                type: 'item',
                icon: 'trending_up',
                url: '/gestion-pedido'
            },
            {
                id: 'configuracion',
                title: 'NAV.CONFIGURACION',
                type: 'collapsable',
                icon: 'settings',
                children: [
                    {
                        id: 'tipoNotaCredito',
                        title: 'NAV.TIPO_NOTA_CREDITO',
                        type: 'item',
                        url: '/configuracion/tipoNotaCredito'
                    },
                    {
                        id: 'causal',
                        title: 'NAV.CAUSAL',
                        type: 'item',
                        url: '/configuracion/causal'
                    },
                    {
                        id: 'subcausal',
                        title: 'NAV.SUBCAUSAL',
                        type: 'item',
                        url: '/configuracion/subcausal'
                    },
                    {
                        id: 'causante',
                        title: 'NAV.CAUSANTE',
                        type: 'item',
                        url: '/configuracion/causante'
                    },
                ]
            }
        ]
    }
];

export const navigationValidador: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'rutero',
                title: 'NAV.RUTERO',
                type: 'item',
                icon: 'trending_up',
                url: '/telemercaderista'
            },
            {
                id: 'consultaExistencias',
                title: 'NAV.CONSULTA_EXISTENCIAS',
                type: 'item',
                icon: 'find_in_page',
                url: '/consultaExistencias'
            },
            {
                id: 'gestionPromociones',
                title: 'NAV.MODIFICAR_PDF',
                translate: 'NAV.MODIFICAR_PDF',
                type: 'item',
                icon: 'picture_as_pdf',
                url: '/validador/modificarPdf'
            }
        ]
    }
];

export const emptyNavigation: FuseNavigation[] = []